import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-tarification',
  standalone: true,
  imports: [CommonModule, HeaderComponent, FooterComponent],
  templateUrl: './tarification.component.html',
  styleUrl: './tarification.component.scss'
})
export class TarificationComponent implements OnInit {

  constructor(
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit(): void {
    // Définir le titre de la page (50 caractères - optimal)
    this.title.setTitle('Tarifs des conversions PDF en Word – pdf-to-word.fr');
    
    // Définir les meta tags SEO (160 caractères - optimal)
    this.meta.updateTag({ name: 'description', content: 'Consultez nos offres pour convertir vos PDF en Word en ligne : 0,50 € pour 24h ou 19,80 € pour 14 jours. Conversion rapide, sécurisée et sans logiciel.' });
    this.meta.updateTag({ name: 'keywords', content: 'tarifs PDF Word, prix conversion PDF, abonnement PDF Word, tarification pdf-to-word, offre conversion PDF, prix PDF en Word, service PDF payant' });
    
    // Meta tags supplémentaires pour le SEO
    this.meta.updateTag({ property: 'og:title', content: 'Tarifs des conversions PDF en Word – pdf-to-word.fr' });
    this.meta.updateTag({ property: 'og:description', content: 'Consultez nos offres pour convertir vos PDF en Word en ligne : 0,50 € pour 24h ou 19,80 € pour 14 jours. Conversion rapide, sécurisée et sans logiciel.' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });
    this.meta.updateTag({ name: 'author', content: 'Interactive Lab' });
  }

}
